import type AuthProvider from '$lib/components/auth/store.svelte';

export class PinterestProvider {
	protected currency: string;
	protected auth: AuthProvider;

	constructor(currency: string, auth: AuthProvider) {
		this.currency = currency;
		this.auth = auth;
	}

	#trackEvent(eventName: string, eventParams?: Record<string, unknown>) {
		if (typeof pintrk !== 'undefined') {
			const userData = this.auth.userData;
			if (userData?.hashedEmail) {
				pintrk('set', { em: userData.hashedEmail });
			}
			pintrk('track', eventName, eventParams);
		}
	}

	trackCheckout(order: SalesOrder) {
		const lineItems = order.items.map((item) => {
			const itemPrice = item.unit_price_excl_tax * item.quantity - item.discount_amount;
			return {
				product_id: item.sku,
				product_name: item.name,
				product_price: parseFloat(itemPrice.toFixed(2)),
				product_quantity: item.quantity,
				product_category: '', // this key must be present to avoid warning
				product_brand: item.brand,
				product_variant: item.variation,
			};
		});

		const total = lineItems.reduce((acc, item) => acc + item.product_price, 0);
		const totalQuantity = order.items.reduce((acc, item) => acc + item.quantity, 0);

		this.#trackEvent('checkout', {
			value: parseFloat(total.toFixed(2)),
			order_quantity: totalQuantity,
			currency: this.currency,
			order_id: order.ref,
			promo_code: order.coupon_code ?? '',
			line_items: lineItems,
		});
	}
}

export default PinterestProvider;
